module.exports = __webpack_public_path__ + "img/OHM.e60fdefe.png";